/** Matches backend `IndustryCatalogConstants.All` / catalog document id. */
export const INDUSTRY_ALL_ID = '00000000-0000-0000-0000-000000000000';

export const INDUSTRY_ALL_SELECTION = [INDUSTRY_ALL_ID] as const;

export interface IndustryDto {
  id: string;
  name: string;
}

export interface SubIndustryDto {
  parentId: string;
  id: string;
  name: string;
  insightId?: string | null;
  vertecId?: string | null;
}

export interface IndustryCatalogGroup {
  industry: IndustryDto;
  subIndustries: SubIndustryDto[];
}

export function isIndustryAllId(value: string): boolean {
  return value.toLowerCase() === INDUSTRY_ALL_ID;
}

export function isIndustryAllSelection(values: readonly string[] | undefined | null): boolean {
  return values?.length === 1 && isIndustryAllId(values[0]);
}

export function isIndustrySelectionValid(values: readonly string[] | undefined | null): boolean {
  if (!values?.length) return false;
  if (isIndustryAllSelection(values)) return true;
  return !values.some(isIndustryAllId);
}
